import { ReactElement } from 'react';
import './ContentHeader.scss';
import CustomButton from '../CustomButton/CustomButton';
import { Icons } from '../../assets/icons/icon';

interface ContentHeaderProps {
    title: string;
    subTitle: string;
    handleBack?: () => void;
    action?: {
        label: string;
        onClick: () => void;
        icon: ReactElement;
        height?: string;
    }
}

export default function ContentHeader({ title, subTitle, handleBack, action }: Readonly<ContentHeaderProps>) {
    return (
        <div className="content-header-wrapper">
            <div className="content-header-left">
                <div className="content-title-wrapper">
                    {handleBack && (
                        <button className="not-a-button content-back" onClick={handleBack}>
                            <img src={Icons.BackArrow} alt='Back' />
                        </button>
                    )}
                    <div className="content-title">{title}</div>
                </div>
                <div className="content-sub-title">{subTitle}</div>
            </div>
            <div className="content-header-right">
                {action &&
                    <CustomButton
                        startIcon={action.icon}
                        text={action?.label}
                        onClick={action.onClick}
                        background='#EBA832'
                        height={action.height}
                    />}
            </div>
        </div>
    )
}